import AboutUs from "./components/about-us/about-us.component"
import ContactPage from "./components/contact-page/contact-page.component"
// import Footer from "./components/footer/footer.component"
import MobileNavigation from "./components/mobile-navigation/mobile-navigation.component"
import Navigation from "./components/navigation/navigation.component"
import PreviewPage from "./components/preview-page/preview-page.component"
import ShortAdd from "./components/short-add/short-add.component"
import ShortAdd2 from "./components/short-add2/short-add2.component"
import WhyUs from "./components/why-us-page/why-us.component"
import Services from "./components/services"
import Qa from "./components/qa/qa.component"
import Restoration from "./components/restoration/restoration.component"

// import { useContext } from "react";
// import { CartContext } from "./contexts/cart.context";
function AllComponentsWrapper({ props, lang }) {
  const { navigation, previewPage, whyUs, shortAdd, aboutUs, shortAdd2,contactsPage,restorationLocale, QALocale } =
    props
  return (
    <div className="App">
      <MobileNavigation props={navigation} />
      <Navigation props={navigation} />
      <PreviewPage props={previewPage} />
      <WhyUs props={whyUs} />
      <ShortAdd props={shortAdd} />
      <AboutUs props={aboutUs} />
      {/*<Services lang={lang} />*/}
      <ShortAdd2 props={shortAdd2} />
      {/*<Restoration props={restorationLocale}/>*/}
      <Qa props={QALocale}/>
      <ContactPage props={contactsPage} />
    </div>
  )
}

export default AllComponentsWrapper
